export const acBrandTypes = {
    loading: "LOADING_ACBRAND",
    delete: "DELETE_ACBRAND",
    loadedOne: "LOADED_ACBRAND",
    loadedMultiple: "LOADED_ACBRANDS",
    success: "SUCCESS_ACBRAND",
    restore: "RESTORE_ACBRAND",
    hardDelete: "HARDDELETE_ACBRAND",
};
